var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column h-100" },
    [
      _c(
        "div",
        { staticClass: "d-flex mb-2" },
        [
          _c("input-debounced", {
            staticClass: "mr-1",
            attrs: { clearable: "", autofocus: true, placeholder: "Search" },
            model: {
              value: _vm.filters.search,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "search", $$v)
              },
              expression: "filters.search",
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-secondary", on: { click: _vm.refresh } },
            [_c("i", { staticClass: "fas fa-sync-alt" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("group-list", { ref: "list", attrs: { url: _vm.url } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }